import { ROLE } from '../types/user';

export const roleRoute = new Map<string, string>();
roleRoute.set(ROLE.ROLE_ADMIN, '/admin');
roleRoute.set(ROLE.ROLE_APPROVER, '/staff');
roleRoute.set(ROLE.ROLE_REVIEWER, '/staff');

export const getRouteByRole = (role: string): string => roleRoute.get(role) ?? '/';
